import { Injectable } from '@angular/core';
import { LoggingService } from '../services/logging.service';

@Injectable()
export class EnvironmentManager {

  constructor(private readonly loggingService: LoggingService) {
  }

  get<T>(environment: T, parameter: keyof T) {
    // Check if the parameter has been defined as an override in local storage
    const item = window.localStorage.getItem(`environment:${String(parameter)}`);
    if (item !== null) {
      return item;
    }

    return environment[parameter];
  }

  loadOverrideParameters() {
    // Check if in the URL, if we are seeing override parameters.
    const urlParams = new URLSearchParams(window.location.search);
    // The structure of the query string override will be:
    // `environmentParameters=encodedJsonString`
    try {
      if (urlParams.has('environmentParameters') === false) {
        return;
      }

      const environmentParameters = JSON.parse(urlParams.get('environmentParameters'));

      for (const [key, value] of Object.entries(environmentParameters)) {
        if (typeof value === 'string') {
          window.localStorage.setItem(`environment:${key}`, value);
        }
      }
    } catch (e) {
      this.loggingService.error(`Error loading the override parameters from the URL: ${e}. Url: ${window.location.href}`);
    }

    // todo: showcase in the debug bar the overridden parameters
  }

  getOverriddenParameters(): { key: string, value: string }[] {
    const parameters = [];
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('environment:')) {
        parameters.push({
          key,
          value: localStorage.getItem(key),
        });
      }
    });

    return parameters;
  }
}